import Vue from 'vue';
import Router from 'vue-router';

import { User } from "./logic/User";
import { Notifications } from "./notification"

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
const Dashboard = () => import('@/views/Dashboard');
const ProjectDetail = () => import('@/views/ProjectDetail');
const BucketDetail = () => import('@/views/BucketDetail');
const DataExplorer = () => import('@/views/DataExplorer');
const AppDetail = () => import('@/views/AppDetail');
const Profile = () => import('@/views/Profile');
const AuthenticationSettings = () => import('@/views/AuthenticationSettings');
const UserSettings = () => import('@/views/UserSettings');
const MessagingSettings = () => import('@/views/MessagingSettings');
const MessagingRequests = () => import('@/views/MessagingRequests');

const ThirdPartyKeys = () => import('@/views/more/ThirdPartyKeys');

const FunctionsOverview = () => import('@/views/functions/FunctionsOverview');

const FilesSettings = () => import('@/views/files/Settings');

Vue.use(Router);

const router = new Router({
  //mode: "history",
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
        redirectIfAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:id',
      name: 'ProjectDetail',
      component: ProjectDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/bucket/:id',
      name: 'BucketDetail',
      component: BucketDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/bucket/:id/explorer',
      name: 'DataExplorer',
      component: DataExplorer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/app/:id',
      name: 'AppDetail',
      component: AppDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/functions',
      name: 'FunctionsOverview',
      component: FunctionsOverview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/files/settings',
      name: 'FilesSettings',
      component: FilesSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/auth_settings',
      name: 'AuthenticationSettings',
      component: AuthenticationSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/user_settings',
      name: 'UserSettings',
      component: UserSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/messaging_settings',
      name: 'MessagingSettings',
      component: MessagingSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/messaging_requests',
      name: 'MessagingRequests',
      component: MessagingRequests,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/third_party_keys',
      name: 'ThirdPartyKeys',
      component: ThirdPartyKeys,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const currentUser = await User.isSignedIn();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const redirectIfAuth = to.matched.some(record => record.meta.redirectIfAuth);

  if (requiresAuth && !currentUser) {
    Notifications.show("You were not signed in.");
    next('/login')
  }
  else if (currentUser && redirectIfAuth) next('/dashboard');
  else next();
});

export default router;
